import { TFunction } from "next-i18next";

export function dateToText(date: string, t: TFunction) {
    if (date) {
        const [fecha,] = date.split(' ');
        let [anio, mes, dia] = fecha.split('-');

        //Si el primer numero de mes es un 0 quitarlo
        if (mes.startsWith('0')) {
            mes = mes[1];
        }

        return `${dia} ${t("common:magic_date.de")} ${t("common:magic_date.mes_" + mes)} ${t("common:magic_date.de")} ${anio}`;
    } else {
        return "";
    }
}

export function dateToDateDB(date: Date) {
    const fecha = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    const hora = date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
    return fecha + " " + hora;
}

export function dateToDateDBT(date: Date) {
    const fecha = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    const hora = date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
    return fecha + "T" + hora;
}

//saca el otro formato el de T

export function obtenerHora(date: string) {
    if (date) {
        const [, hora] = date.split(' ');
        return hora;
    } else {
        return "";
    }
}

export function dateToTextTForm(date: string, t: TFunction) {
    if (date) {
        const [fecha,] = date.split('T');
        let [anio, mes, dia] = fecha.split('-');
        //Si el primer numero de mes es un 0 quitarlo
        if (mes.startsWith('0')) {
            mes = mes[1];
        }
        return `${dia} ${t("common:magic_date.de")} ${t("common:magic_date.mes_" + mes)} ${t("common:magic_date.de")} ${anio}`;
    } else {
        return "";
    }
}

//Obtener la hora de la fecha Tform
export function obtenerHoraTForm(date: string) {
    if (!date) {
        return "";
    }

    const valor = date.trim();
    const tieneZona = /([zZ]|[+-]\d{2}:\d{2})$/.test(valor);
    const dosDigitos = (num: number): string => (num < 10 ? `0${num}` : `${num}`);

    let fechaLocal: Date;

    if (tieneZona) {
        // Si trae Z/+hh:mm/-hh:mm, JS ya conoce la zona de origen y lo convierte a local.
        fechaLocal = new Date(valor);
    } else {
        // Si no trae zona, el backend lo manda en UTC: forzamos parseo como UTC.
        const match = valor.match(/^(\d{4})-(\d{2})-(\d{2})[T\s](\d{2}):(\d{2})(?::(\d{2}))?/);

        if (!match) {
            const fallback = new Date(valor);
            return Number.isNaN(fallback.getTime())
                ? ""
                : `${dosDigitos(fallback.getHours())}:${dosDigitos(fallback.getMinutes())}:${dosDigitos(fallback.getSeconds())}`;
        }

        const [, anio, mes, dia, hora, minuto, segundo = '0'] = match;
        fechaLocal = new Date(
            Date.UTC(
                Number(anio),
                Number(mes) - 1,
                Number(dia),
                Number(hora),
                Number(minuto),
                Number(segundo)
            )
        );
    }

    if (Number.isNaN(fechaLocal.getTime())) {
        return "";
    }

    return `${dosDigitos(fechaLocal.getHours())}:${dosDigitos(fechaLocal.getMinutes())}:${dosDigitos(fechaLocal.getSeconds())}`;
}

//Comprobar si una fecha esta caducada segun la fecha actual y los dias de caducidad
export function estaCaducada(date: string, diasCaducidad: number) {
    if (date) {
        const fechaCompra = new Date(date);
        const fechaActual = new Date();
        const diferenciaDias = (fechaActual.getTime() - fechaCompra.getTime()) / (1000 * 3600 * 24);
        return diferenciaDias > diasCaducidad;
    }
    return false;
}
